import React, { FC } from 'react';
import FieldCheckbox from '../../atoms/field-checkbox/field-checkbox';

interface Props {
  type: 'radio' | 'checkbox';
  items: { value: string; label: string; count: number }[];
  selectedItems: string[] | null;
  onChange: (selectedItems: string[]) => void;
}

const ProductListingRefineAccordionItemList: FC<Props> = ({
  type,
  items,
  selectedItems,
  onChange,
}) => {
  return (
    <ul className="grid gap-2">
      {items.map((item) => (
        <li key={item.value}>
          <FieldCheckbox
            disabled={item.count === 0}
            theme={type}
            label={
              <>
                <span
                  className={`
                    ${item.count === 0 ? 'text-grey-600' : 'text-black'}
                    pr-2
                  `}
                >
                  {item.label}
                </span>
                <span className="text-grey-600">({item.count})</span>
              </>
            }
            value={selectedItems?.includes(item.value)}
            onChange={(value) => {
              if (type === 'radio') {
                onChange(value ? [item.value] : null);
              } else {
                onChange(
                  value
                    ? [...(selectedItems || []), item.value]
                    : selectedItems.filter(
                        (selectedFacet) => selectedFacet !== item.value
                      )
                );
              }
            }}
          />
        </li>
      ))}
    </ul>
  );
};

export default ProductListingRefineAccordionItemList;
